import React, { useEffect, useState } from "react";
import { Container } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { VerticalBarSeries, XYPlot, VerticalGridLines, HorizontalGridLines, XAxis, YAxis, RadialChart } from "react-vis";
import { dashhboardQuery, getcurrentUserProfileUser } from "./dashboardActions";
import firebase from "../../app/config/firebase";

export default function DashboardPage(props) {
    const [users, setUsers] = useState([]);
    const [leads_by_source, setLeads_by_source] = useState([]);
    const history = useHistory();

    const { currentUserProfile } = useSelector((state) => state.profile);

    useEffect(() => {
        dashQuery();
    }, []);

    useEffect(() => {
        // if we dont have a user profile, sign out
        console.log(typeof currentUserProfile?.isExternal);
        console.log(typeof currentUserProfile?.isConsultant);
        if (currentUserProfile && (typeof currentUserProfile?.isExternal === "undefined" && typeof currentUserProfile?.isConsultant === "undefined")) {
            firebase.auth().signOut();
        }

        if (currentUserProfile?.isLoaded === true && currentUserProfile?.isEmpty === true) {
            history.push("/");
        }
    }, [currentUserProfile, history]);

    async function dashQuery() {
        try {
            let query = await dashhboardQuery();
            setUsers(query.users || []);
            setLeads_by_source(query.leads_by_source || {});
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    }

    let new_pickups_data = [];

    if (users && users.length > 0) {
        Object.keys(users).forEach(function (key) {
            let name = users[key].email;
            if (users[key].displayName) {
                name = users[key].displayName;
            }

            new_pickups_data.push({
                x: name,
                y: users[key].leads_count,
            });
        });
    }

    let leads_by_source_data = [];

    const sourceArr = ["Telephone", "Email", "Chat", "Website", "Social Media", "Repeat Client", "Referral", "Mailchimp/Mailer", "Other"];

    for (let i = 0; i < sourceArr.length; i++) {
        if (typeof leads_by_source[sourceArr[i]] !== "undefined") {
            leads_by_source[sourceArr[i]].label = leads_by_source[sourceArr[i]].label + " = " + leads_by_source[sourceArr[i]].angle;

            leads_by_source_data.push(leads_by_source[sourceArr[i]]);
        }
    }

    return (
        <Container>
            <h2>Dashboard</h2>
            <h3>Consultants - New enquiries picked up</h3>

            <XYPlot xType="ordinal" stackBy="y" width={1100} height={200}>
                <VerticalGridLines />
                <HorizontalGridLines />
                <XAxis />
                <YAxis />
                <VerticalBarSeries cluster="2015" color="#12939A" data={new_pickups_data} />
            </XYPlot>

            <h3>Enquiries by Source</h3>
            <RadialChart data={leads_by_source_data} width={500} height={500} showLabels={true} />
        </Container>
    );
}
